module.exports = __webpack_public_path__ + "img/user-icon.542c5e7a.svg";